import React, { useEffect, useState } from "react";
import { Grid, Box, Checkbox, Typography } from "@mui/material";
import "./CurrentSalaryEditModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import { fonts, themes } from "../../../themes/themes";
import emptyIcon from "../../../../assets/images/empty_icon.svg";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
import Compdirection from "../../../themes/CompDirection";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackData: (data: any) => void;
  allAdditionalBenefitsData: any;
  allAllowancesData: any;
  paymentMethod: string;
  salaryStartDate: any;
  trans?: any;
}

const CurrentSalaryEditModalPresenter = ({
  isModalOpen,
  closeModal,
  paymentMethod,
  allAllowancesData,
  allAdditionalBenefitsData,
  salaryStartDate,
  callBackData,
  trans,
}: ModalProps) => {
  const [startDate, setStartDate] = useState<any>(salaryStartDate);

  const [salaryVal, setSalaryVal] = useState<any>({});
  const [benefitsVal, setBenefitsVal] = useState<any>({});

  const [allAllowanceNames, setAllAllowanceNames] = useState<any>([]);
  const [allowanceKeys, setAllowanceKeys] = useState<any>([]);
  const [allowanceValues, setAllowanceValues] = useState<any>([]);

  const [allBenefitsNames, setAllBenefitsNames] = useState<any>([]);
  const [benefitsKeys, setBenefitsKeys] = useState<any>([]);
  const [benefitsValues, setBenefitsValues] = useState<any>([]);

  const [paymentMethodName, setPaymentMethodName] = useState(paymentMethod);
  const [paymentMethodId, setPaymentMethodId] = useState(paymentMethod);

  const paymentMethods = [
    {
      id: "Bank Transfer",
      name: "Bank Transfer",
    },
    {
      id: "Cash",
      name: "Cash",
    },
    {
      id: "WPS Transfer",
      name: "WPS Transfer",
    },
  ];
  const handlePaymentMethod = (paymentName: any) => {
    const payment = _.filter(paymentMethods, function (p: any) {
      return p.name === paymentName;
    });
    if (payment.length) {
      const payment_type = payment[0];
      setPaymentMethodId(payment_type.id);
      setPaymentMethodName(paymentName);
    }
  };
  const handleSubmit = () => {
    const allowance_list: any = [];
    for (let i = 0; i < allowanceKeys.length; i++) {
      let record = {};
      if (allowanceKeys[i] && allowanceValues[i]) {
        record = {
          allowance_type_id: allowanceKeys[i],
          value: allowanceValues[i],
          title: allAllowanceNames[i],
          type: "amount",
        };
        allowance_list.push(record);
      }
    }

    const benefits_list: any = [];
    for (let i = 0; i < benefitsKeys.length; i++) {
      let record = {};
      if (benefitsKeys[i] && benefitsValues[i]) {
        record = {
          allowance_type_id: benefitsKeys[i],
          value: benefitsValues[i],
          title: allBenefitsNames[i],
          type: "amount",
        };
        benefits_list.push(record);
      }
    }

    callBackData({
      all_allowances: allowance_list,
      all_benefits: benefits_list,
      start_date: startDate,
      paymentMethod: paymentMethodId,
    });
    closeModal();
  };

  useEffect(() => {
    const allownce_record: any = {};
    const data = _.map(allAllowancesData, (allowance: any) => {
      allAllowanceNames.push(allowance.title);
      allownce_record[allowance.allowance_type_id] = allowance.value;
      return allownce_record;
    });
    setSalaryVal(allownce_record);

    const benefit_record: any = {};
    const data_benefits = _.map(allAdditionalBenefitsData, (benefit: any) => {
      allBenefitsNames.push(benefit.title);
      benefit_record[benefit.other_allowance_type_id] = benefit.amount;
      return benefit_record;
    });
    setBenefitsVal(benefit_record);

    /*
      If salary not change! 
    */

    const allowance_k = [...allowanceKeys];
    const allowance_v = [...allowanceValues];
    _.map(allAllowancesData, (data: any) => {
      allowance_k.push(data?.allowance_type_id);
      allowance_v.push(data?.value);
    });
    setAllowanceKeys(allowance_k);
    setAllowanceValues(allowance_v);

    const benefit_k = [...benefitsKeys];
    const benefit_v = [...benefitsValues];
    _.map(allAdditionalBenefitsData, (data: any) => {
      benefit_k.push(data?.other_allowance_type_id);
      benefit_v.push(data?.amount);
    });
    setBenefitsKeys(benefit_k);
    setBenefitsValues(benefit_v);

    //-------------^^^^^^^^^

    const allowance_list: any = [];
    for (let i = 0; i < allowanceKeys.length; i++) {
      let record = {};
      if (allowanceKeys[i] && allowanceValues[i]) {
        record = {
          allowance_type_id: allowanceKeys[i],
          value: allowanceValues[i],
          title: allAllowanceNames[i],
          type: "amount",
        };
        allowance_list.push(record);
      }
    }
    const benefits_list: any = [];
    for (let i = 0; i < benefitsKeys.length; i++) {
      let record = {};
      if (benefitsKeys[i] && benefitsValues[i]) {
        record = {
          allowance_type_id: benefitsKeys[i],
          value: benefitsValues[i],
          title: allBenefitsNames[i],
          type: "amount",
        };
        benefits_list.push(record);
      }
    }
  }, []);

  const handleAllowanceChange = (event: any, id: any, title: any) => {
    const current = { ...salaryVal };

    current[id] = event.target.value;

    if (!allAllowanceNames.includes(title)) {
      allAllowanceNames.push(title);
    }

    setSalaryVal(current);

    const entries = Object.entries(current);
    const c_keys: any = entries.map(([key, val]) => {
      return key;
    });
    if (c_keys) setAllowanceKeys(c_keys);
    const c_valuess: any = entries.map(([key, val]) => {
      return val;
    });
    if (c_valuess) setAllowanceValues(c_valuess);
  };

  const handleAdditionalBenefitChange = (event: any, id: any, title: any) => {
    const current = { ...benefitsVal };

    current[id] = event.target.value;

    if (!allBenefitsNames.includes(title)) {
      allBenefitsNames.push(title);
    }

    setBenefitsVal(current);

    const entries = Object.entries(current);
    const c_keys: any = entries.map(([key, val]) => {
      return key;
    });
    if (c_keys) setBenefitsKeys(c_keys);
    const c_valuess: any = entries.map(([key, val]) => {
      return val;
    });
    if (c_valuess) setBenefitsValues(c_valuess);
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Edit Current Salary") }}
        closeModal={closeModal}
      />
      {allAdditionalBenefitsData?.length || allAllowancesData?.length ? (
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "35px",
          }}
        >
          <Compdirection>
            {_.map(allAllowancesData, (allowance: any) => {
              return (
                <Grid item xs={6}>
                  <CustomTextField
                    type="string"
                    value={salaryVal[allowance.allowance_type_id]}
                    label={allowance.title}
                    onChange={(e: any) =>
                      handleAllowanceChange(
                        e,
                        allowance.allowance_type_id,
                        allowance.title
                      )
                    }
                  />
                </Grid>
              );
            })}
            <Grid item xs={12} style={{ marginTop: "5px" }}>
              <Typography className="benefit-heading">
                {trans("Additional Benefits")}
              </Typography>
            </Grid>
            {_.map(allAdditionalBenefitsData, (benefit: any) => {
              return (
                <Grid item xs={6}>
                  <CustomTextField
                    type="string"
                    label={benefit.title}
                    value={benefitsVal[benefit.other_allowance_type_id]}
                    onChange={(e: any) =>
                      handleAdditionalBenefitChange(
                        e,
                        benefit.other_allowance_type_id,
                        benefit.title
                      )
                    }
                  />
                </Grid>
              );
            })}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={6} style={{ marginTop: "5px" }}>
                  <CustomDatePicker
                    label={trans("Start Date")}
                    value={new Date(startDate)}
                    onChange={(newValue: any) => {
                      setStartDate(newValue);
                    }}
                  />
                </Grid>
                <Grid item xs={6} style={{ marginTop: "5px" }}>
                  <CustomAutoComplete
                    label={trans("Payment Method")}
                    options={_.map(paymentMethods, (method: any) => {
                      return method.name;
                    })}
                    value={paymentMethodName}
                    onChange={(event: any, newValue: any) => {
                      handlePaymentMethod(newValue);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Compdirection>
        </Grid>
      ) : (
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              textAlign: "center",
            }}
          >
            <img src={emptyIcon} />
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              textAlign: "center",
            }}
          >
            <Typography
              style={{
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                color: themes.defaultIcon,
              }}
            >
              {trans("Current Salary Not set")}
            </Typography>
          </Grid>
        </Grid>
      )}
      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
        isSubmitButton={
          allAdditionalBenefitsData?.length || allAllowancesData?.length
            ? true
            : false
        }
      />
    </CustomModal>
  );
};

export default CurrentSalaryEditModalPresenter;
